import React, {useEffect, useState} from 'react';
import {getFilterQcStatus} from "../../microComponents/tablePages/getFilterQcStatus";
import GetProductList from "../Products/GetProductList";
import FilterSelectOption from "../../microComponents/tablePages/filter/FilterSelectOption";
import DateFilter from "../../microComponents/tablePages/filter/DateFilter";


const TopSearchBatchHistory = () => {

    const [productList, setProductList] = useState([]);
    const [productListLoading, setProductListLoading] = useState(false);
    const [qcStatusList, setQcStatusList] = useState([]);
    const [qcStatusLoading, setQcStatusLoading] = useState(false);

    useEffect(() => {
        GetProductList(setProductList, setProductListLoading)
        getFilterQcStatus(setQcStatusList, setQcStatusLoading)

    }, [])
    return (<div className='grid grid-cols-1 2xs:grid-cols-2 sm:grid-cols-3 md:grid-cols-4   gap-x-4  gap-y-5 mt-10   '>


        <FilterSelectOption data={{
            filterName: 'product',
            className: 'xs:hidden',
            loading: productListLoading,
            placeholder: 'محصول',
            options: productList
        }}/>

        <DateFilter
            data={{
                className: 'lg:hidden',
                placeholder: ['تاریخ ثبت تا', 'تاریخ ثبت از'],
                filterName: ['FromCreated', 'ToCreated'],
            }}
        />


        <FilterSelectOption data={{
            placeholder: 'QC',
            filterName: 'qualityControlAdmin',
            className: 'lg:hidden',
// todo
            options: qcStatusList,
            loading: qcStatusLoading,

        }}/>


    </div>);
};

export default TopSearchBatchHistory;
